import React from 'react';

export default {
  width: 13,
  height: 9,
  content: <path d="M12.7 1.7L5.3 8.3.3 4l1.4-1.5 3.6 3.3 6-5.4 1.4 1.4z" />
};
